import get from "lodash/get";
import {
    deleteInvoiceClientItemLoading,
    deleteInvoiceClientItemReject,
    deleteInvoiceClientItemRequest,
    deleteInvoiceClientItemSuccess,
    deleteInvoiceClientItemReset,
} from "../../actions/invoiceClient/deleteItem";

export const deleteInvoiceClientItem = (InvoiceId, InvoiceDetailId) => async (dispatch, getState) => {
    dispatch(deleteInvoiceClientItemLoading());
    try {
        const { data } = await deleteInvoiceClientItemRequest({ InvoiceId, InvoiceDetailId }, getState);
        dispatch(deleteInvoiceClientItemSuccess(data));
    } catch (error) {
        dispatch(deleteInvoiceClientItemReject(get(error, "response.data", error)));
    } finally {
        setTimeout(() => { dispatch(deleteInvoiceClientItemReset()); }, 3000);
    }
    return Promise.resolve();
};
